import api from './api';

export interface Objective {
  id: number;
  title: string;
  description: string;
  objective_type: 'skill' | 'course' | 'exercise_pattern';
  skill: number | null;
  skill_name: string | null;
  course: number | null;
  course_title: string | null;
  exercise_pattern: number | null;
  exercise_pattern_title: string | null;
  tags: string[];
  created_by: number;
  created_by_name: string;
  created_at: string;
  updated_at: string;
  can_edit: boolean;
  order: number;
  weight: number;
  container: number | null;
  is_public: boolean;
}

class ObjectiveService {
  async getAll(params?: any): Promise<Objective[]> {
    const response = await api.get('/objectives/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getObjective(id: number): Promise<Objective> {
    const response = await api.get(`/objectives/${id}/`);
    return response.data;
  }

  async create(data: Partial<Objective>): Promise<Objective> {
    const response = await api.post('/objectives/', data);
    return response.data;
  }

  async update(id: number, data: Partial<Objective>): Promise<Objective> {
    const response = await api.patch(`/objectives/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/objectives/${id}/`);
  }

  async reorder(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/objectives/reorder/', { items });
  }

  async getAvailableObjectives(): Promise<Objective[]> {
    const response = await api.get('/objectives/available/');
    return response.data;
  }
}

const objectiveService = new ObjectiveService();
export default objectiveService;
